/* *********** 理赔中心 *********** */

import { permissionInfoStore } from '@/stores/userInfo'
import { validateUserPermission } from '@/utils/permission'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import claimCenterRoutes from './claimCenter'
import ibuClaimCenterRoutes from './ibuClaimCenter'
import presidentRoutes from './president'

// 1、创建路由规则
const routes = [
  // 访问地址： http://localhost:8080/#/claimCentre
  // {
  //   path: '/',
  //   redirect: '/claimCentre',
  // },
  // //错误提示页
  // {
  //   path: '/error',
  //   name: 'error',
  //   component: () => import('@/views/error/index.vue'),
  // },
  // ...claimCenterRoutes, // 理赔中心
  // ...presidentRoutes, // 总裁专项页面链接
  ...ibuClaimCenterRoutes, // 国际理赔中心
]

// 2、创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const title = to.meta?.title
  if (title) {
    document.title = `${title}`
  }

  // 错误页面
  // if (from.path === '/error' || to.path === '/error') {
  //   next()
  //   return
  // }

  // // 鉴权
  // const { succ, result, msg } = await validateUserPermission(to, from)
  // const { toName, options } = result || {}
  // // const { permissionAble } = permissionInfoStore();
  // // console.log('--result', result, '--succ', succ);
  // // console.log('--toName', toName, '--permissionAble', permissionAble);

  // if (succ) {
  //   if (toName) {
  //     next({
  //       name: toName,
  //       query: { ...options },
  //     })
  //   } else {
  next()
  //   }
  //   return
  // }

  // // 链接已失效 or 鉴权不通过
  // next({
  //   path: '/error',
  //   query: {
  //     errorMessage: msg,
  //     fromPath: from.path,
  //   },
  // })
})

export default router
